<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar>
      <mobile-menu @dashLoading="dashLoading"></mobile-menu>
      <template slot="links">
        <template v-for="(menuModule, key) in activeModules">
          <activate-menu
            :key="key"
            v-if="menuModule.level == 1"
            :userModules="user_modules"
            :menuModule="menuModule"
            @dashLoading="dashLoading"
            @loadIconContent="loadIconContent"
          />
        </template>
        <template v-for="(menuModule, key) in inactiveModules">
          <inactivate-menu
            :key="key"
            v-if="menuModule.level == 1"
            :userModules="user_modules"
            :menuModule="menuModule"
            @dashLoading="dashLoading"
            @loadIconContent="loadIconContent"
          />
        </template>
      </template>
    </side-bar>
    <div class="main-panel">
      <loading
        :active.sync="isDashLoading"
        :can-cancel="false"
        :color="'#f18f00'"
        :is-full-page="false"
        :height="100"
        :width="255"
        :opacity="0.8"
        class="custom-loading-dash"
      >
      </loading>
      <top-navbar @dashLoading="dashLoading"></top-navbar>
      <div class="custom-container-fluid">
        <img :src="iconContent" alt="" class="custom-breadcrumb" />
        <a class="navbar-brand">{{ $t(this.$route.name) }}</a>
      </div>
      <dashboard-content
        @click.native="toggleSidebar"
        @dashLoading="dashLoading"
        @forceRerenderMenu="forceRerenderMenu"
      >
      </dashboard-content>
      <content-footer></content-footer>
    </div>
    <el-button
      v-if="showManualOption"
      v-tooltip.top-center="$t('common_words.manuals')"
      class="manual-float"
      @click="downloadManual"
      icon="el-icon-document"
    />
    <el-button
      v-tooltip.top-center="$t('common_words.scrollUp')"
      class="float"
      @click="topPage"
      icon="el-icon-top"
    />
  </div>
</template>
<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import { Axios } from 'src/class/Axios.js';
import { DISK_URL } from 'src/util/Util';
import { isset } from 'src/util/Util.js';
import ActivateMenu from './Menu/ActivateMenu.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import i18n from '../../i18n';
import InactivateMenu from './Menu/InactivateMenu.vue';
import Loading from 'vue-loading-overlay';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MobileMenu from './MobileMenu.vue';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import TopNavbar from './TopNavbar.vue';

export default {
  components: {
    [ActivateMenu.name]: ActivateMenu,
    [InactivateMenu.name]: InactivateMenu,
    ContentFooter,
    DashboardContent,
    Loading,
    MobileMenu,
    TopNavbar,
  },
  data() {
    return {
      icon: '/static/img/Logo SmartCultivo.svg',
      business: 2,
      isDashLoading: false,
      form: {
        login: '',
        password: '',
        remember_me: false,
      },
      inputTypePass: 'password',
      iconBtnPass: 'fa fa-eye',
      iconContent: null,
      modules: [],
      user_modules: [],
      showManualOption: false,
      currentModule: null,
      urlDownloadManual: null,
    };
  },
  mixins: [MixinPermissions, MixinMasters],
  computed: {
    activeModules() {
      if (!this.modules || this.modules.length === 0) return [];
      return this.modules.filter((module) => {
        if (this.verifyModuleAuthorization(module.id)) return module;
      });
    },
    inactiveModules() {
      if (!this.modules || this.modules.length === 0) return [];
      return this.modules.filter((module) => {
        if (!this.verifyModuleAuthorization(module.id)) return module;
      });
    },
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    topPage() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    dashLoading(value) {
      this.isDashLoading = value;
    },

    forceRerenderMenu() {
      this.drawMenu();
    },

    loadIconContent(icon) {
      this.iconContent = '/static/img/iconos/' + icon + '.svg';
    },

    showMessageAccess() {
      SweetAlert.warning(i18n.t('vie.Lay.DashboardLayout.noPermissions')).then(
        () => {
          this.$router.go(-1);
        }
      );
    },

    verifyModuleAuthorization(idModule) {
      if (this.user_modules.includes(idModule)) {
        return true;
      }
      return false;
    },

    drawMenu() {
      this.modules = this.$store.state.auth.user.all_modules;
      this.user_modules = this.$store.state.auth.user.user_modules;
    },

    downloadManual() {
      try {
        window.open(this.urlDownloadManual, '_blank');
      } catch (error) {
        SweetAlert.warning(i18n.t('common_words.errorLoadingManual'));
      }
    },

    fetchModuleManual() {
      const data = {
        route: 'modules/getmoduledata',
        url: this.currentModule,
      };

      Axios.postMasters(data)
        .then((response) => {
          const res = response.data.data;
          if (isset(res.manuals)) {
            this.showManualOption = true;
            const fileName = res.manuals[0];
            const diskName = 'module_manuals';
            this.urlDownloadManual = `${DISK_URL}${diskName}/${
              this.currentModule
            }/${encodeURIComponent(fileName)}`;
          } else {
            this.showManualOption = false;
          }
        })
        .catch((error) => {
          this.showManualOption = false;
        });
    },
  },

  beforeCreate() {
    if (
      sessionStorage.getItem('editForm') &&
      this.$route.path !=
        JSON.parse(sessionStorage.getItem('editForm')).url_path_form
    ) {
      sessionStorage.removeItem('editForm');
    }
  },

  created() {
    try {
      this.currentModule = sessionStorage.getItem('urlModule').substring(1);
      this.fetchModuleManual();
    } catch (error) {
      this.showManualOption = false;
    }

    sessionStorage.setItem('urlModule', this.$route.path);
    this.drawMenu();

    let exists = false;

    for (
      let index = 0;
      index < this.$store.state.auth.user.modules_urls.length;
      index++
    ) {
      if (
        this.$route.path.includes(
          '/' + this.$store.state.auth.user.modules_urls[index]
        )
      ) {
        exists = true;
        break;
      }
    }

    if (!exists) {
      this.$router.push('/notaccess');
    } else {
      if (this.$route.path.includes('create') && !this.isCreate())
        this.showMessageAccess();
    }

    setTimeout(() => {
      let logo = document.getElementsByClassName('custom-logo-sidebar');
      logo[0].style.maxWidth = '58px';
      this.$sidebar.toggleMinimize();
    }, 200);

    store.dispatch('auth/validateActiveSession').then((response) => {
      if (
        response.data.session == 0 ||
        (response.data.session == 1 && response.data.token == 0)
      ) {
        this.routeLogin(
          !(response.data.session == 1 && response.data.token == 0)
        );
      } else {
        store.dispatch('auth/validatePassTime', store.state.auth.user.id);
      }
    });

    let icon = this.$store.state.auth.user.business.find(
      (buss) => buss.icon != null
    );
    if (icon !== undefined) {
      icon = icon.icon;
      this.icon =
        icon !== null && icon !== undefined
          ? '/static/img/' + icon
          : '/static/img/Logo SmartCultivo.svg';
    } else {
      this.icon = '/static/img/Logo SmartCultivo.svg';
    }
  },

  mounted() {
    let downtime = localStorage.getItem('downtime');
    var mouseStop = null;
    document.addEventListener('mousemove', () => {
      clearTimeout(mouseStop);
      mouseStop = setTimeout(() => {
        if (
          this.$route.name != 'Login' &&
          this.$route.name != 'PasswordReset'
        ) {
          SweetAlert.warning(i18n.t('vie.Lay.DashboardLayout.inactiveSession'));
          let data = {
            user: this.$store.state.auth.user.username,
            name:
              this.$store.state.auth.user.first_name +
              ' ' +
              this.$store.state.auth.user.last_name,
            avatar: this.$store.state.auth.user.avatar,
            active: 0,
          };
          localStorage.setItem('user', JSON.stringify(data));
          localStorage.removeItem('token');
          clearTimeout(mouseStop);
          this.$router.push('/lock').catch((e) => {
            console.log(e);
          });
        }
      }, downtime * 60000);
    });
  },

  updated() {
    const urlModule = sessionStorage.getItem('urlModule').substring(1);
    if (urlModule !== this.currentModule) {
      this.currentModule = urlModule;
      this.fetchModuleManual();
    }
  },
};
</script>
<style>
.float,
.manual-float {
  position: fixed;
  width: 40px;
  height: 40px;
  bottom: 100px;
  right: 15px;
  background-color: #148c44 !important;
  color: #fff;
  border: none !important;
  border-radius: 50px !important;
  box-shadow: 2px 2px 3px #999;
  z-index: 999;
  display: flex;
  justify-content: center;
  transition: background-color 0.3s, color 0.3s;
}

.float {
  bottom: 40px !important;
}

.manual-float .el-icon-document {
  font-size: 26px;
  position: absolute;
  top: 6px;
}
.float .el-icon-top {
  font-size: 30px;
  position: absolute;
  top: 7px;
  left: 4px;
}

.float:hover,
.float:focus,
.manual-float:hover,
.manual-float:focus {
  color: #148c44;
  background-color: #fff !important;
}
</style>
